export const DEDICATED_FEED_POST_TYPES = new Set([
  "battle",
  "comparison",
  "flex",
  "question",
]);

export const BATTLE_FEED_POST_TYPES = new Set(["battle", "comparison"]);

export const filterPostsForMainFeed = (posts = []) =>
  posts.filter((post) => !DEDICATED_FEED_POST_TYPES.has(post?.postType));

export const filterPostsForBattlesFeed = (posts = []) =>
  posts.filter((post) => BATTLE_FEED_POST_TYPES.has(post?.postType));

export const filterPostsForFlexFeed = (posts = []) =>
  posts.filter((post) => post?.postType === "flex");

export const filterPostsForAskFeed = (posts = []) =>
  posts.filter((post) => post?.postType === "question");

/** Remove expired battles from mixed discovery feeds (client-side safety net). */
export const filterExpiredBattles = (posts = []) => {
  const now = Date.now();
  return posts.filter((post) => {
    if (!BATTLE_FEED_POST_TYPES.has(post?.postType)) return true;
    if (!post?.endsAt) return true;
    return new Date(post.endsAt).getTime() > now;
  });
};
